<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column cabinet__tbody-column--organization">
      {{ name }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--nmc cabinet__tbody-column--right">
      <p>{{ inn }}</p>
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--status">
      {{ status }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--statements">
      <div class="statements-container">
        <span
          v-for="statement of statements"
          :key="statement.id"
          class="statement-item"
          :class="[statement.class]"
        />
      </div>
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--actions">
      <div class="actions-container">
        <router-link :to="routerData">
          <button
            class="action-item tooltip__list-item-img--show"
            @click="setOrganizationId"
          />
        </router-link>
        <a
          download
          target="_blank"
          :href="item.src"
        ><button class="action-item tooltip__list-item-img--document" /></a>
        <!--button class="action-item tooltip__list-item-img--delete" @click="removeItem"></button-->
      </div>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'OrganizationsTableItem',
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    ...mapState('appService', ['filterType']),
    name() {
      return this.item.name;
    },
    status() {
      return this.item.status || '';
    },
    inn() {
      return this.item.inn || '';
    },
    statements() {
      const result = [];
      if (this.item?.greenStatements) {
        result.push({
          id: 'green',
          class: 'statement-item--green',
        });
      }
      if (this.item?.yellowStatements) {
        result.push({
          id: 'yellow',
          class: 'statement-item--yellow',
        });
      }
      if (this.item?.redStatements) {
        result.push({
          id: 'red',
          class: 'statement-item--red',
        });
      }
      return result;
    },
    routerData() {
      return { name: this.filterType === 'PartnerOrganizations' ? 'PartnerOrganizationDetails' : 'CustomerOrganizationDetails', params: { id: this.item.id } };
    },
  },
  methods: {
    ...mapActions('admin', ['setCurrentOrganizationID']),
    removeItem() {
      // eslint-disable-next-line no-alert
      alert(`Метод удаления (id: ${this.item.id})`);
    },
    setOrganizationId() {
      this.setCurrentOrganizationID(this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}
</style>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}
</style>
